import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { selectLanguageData } from '../state/selectors';
import { loadLanguageData } from '../state/actions';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  token: any;
  method: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  lang: any = {}
  selectedLanguage: any;
  customerID: any;
  fuseBillKey: any;
  paymentform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });
  fusbillinfocaptchavalue: any;
  url: any;
  paymentUri: any;
  paymentsuccessuri: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private store: Store<{ languageData: [] }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
  }

  ngOnInit(): void {
    // collecting data from params
    this.token = this.route.snapshot.queryParams['token'];
    this.method = this.route.snapshot.queryParams['method'];
    console.log(this.token, this.method)

    // get language strings
    this.getLanguageTokens();

    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    this.url = window.origin + "/";
    this.paymentUri = this.url + "home";
    this.paymentsuccessuri = this.url + "home";

    // add validations to payment Form
    this.paymentform = this.formBuilder.group({
      cutomerId: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: ["", Validators.compose([Validators.required, Validators.pattern('^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      recaptchaReactive: ["", Validators.required],
    })
  }

  public getLanguageTokens() {
    // api call
    this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    // keep track when ever data get changed
    this.languageData$.subscribe(data => {
      if (data) {
        // if it is has some language strings data
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        setTimeout(() => {
          this.lang = {};
          // get lanugage
          this.selectedLanguage = sessionStorage.getItem("language") ?? 'English'

          // add only those values to a unique key
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
        }, 0)
      }
    })
  }

  closePaymentInfo() {
    this.paymentform.reset();
    this.paymentform.get('expireMonth')?.setValue('');
    this.paymentform.get('expireYear')?.setValue('');
  }

  // ensuring user not entered a empty character
  checkFirstCharacter(event: any, form: any) {
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
  }

}
